// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as OrderDetailsMapStateMapper from "../entity-mapper/OrderDetailsMapStateMapper.bs.js";

var execute = OrderDetailsMapStateMapper.execute;

var OrderDetailsMapConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var OrderDetailsMapResponseConverter = partial_arg(OrderDetailsMapConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  OrderDetailsMapConfig ,
  OrderDetailsMapResponseConverter ,
  
}
/* OrderDetailsMapResponseConverter Not a pure module */
